<template>
	<loader v-if="loading || loadingSeriesAndVolumes" height="80vh" />
	<div v-else class="container ar">
		<div class="head">
			<breadcrumbs
				class="ar"
				:links="[
					{ name: $t('links.home'), link: '/' },
					{ name: $t('links.series'), link: { name: 'all-series' } },
					{
						name: serie.name,
						link: { name: 'serie', params: { id: serieId, name: serieName } },
					},
					{
						name: volumeName.replaceChar('-', ' '),
						link: {
							name: 'all-articles',
							params: { id: volumeId, name: volumeName },
						},
					},
					{
						name: article.ar.name,
						link: {},
						active: true,
					},
				]"></breadcrumbs>

			<!-- top -->
			<div class="top">
				<div class="serie">
					<img :src="serie.image" alt="" />
					<span>{{ serie.name }}</span>
				</div>
				<div class="issue">{{ volumeName.replaceChar('-', ' ') }}</div>
			</div>

			<!-- h-main -->
			<div class="h-main">
				<div class="date" v-if="article.ar.approved_Date">
					{{ $t('articles-page.date') }}
					{{ momentRev(article.ar.approved_Date).format('YYYY MMMM DD') }}
				</div>
				<div class="title">
					<div class="t-ar ar">
						<!-- نمذجة النظام الكهروشمسي والتحكم به لتغذية القمر الصناعي المكعب -->
						{{ article.ar.name }}
					</div>
					<div class="t-en en">
						<!-- Mobdeling and control solar system to feed the cubic satellite -->
						{{ article.en.name }}
					</div>
				</div>
				<div>
					<div class="name" v-for="publisher in article.ar.publishers_ids" :key="publisher.id">
						<img
							:src="
								publisher.publisherName.image
									? publisher.publisherName.image
									: '/assets/Icons/user.png'
							"
							alt="" />
						<router-link
							:to="{
								name: 'publisher',
								params: {
									id: publisher.publisherName.id,
									name: publisher.publisherName.name.replaceSpace(),
								},
							}">
							<div class="n-ar">
								{{ publisher.publisherName.name }}
								(
								{{ publisher.statusTitle.name }}
								)
							</div>
							<!-- <div class="n-en en">
								{{ publisher.name.en }}
							</div>  -->
						</router-link>
					</div>
				</div>
			</div>
		</div>

		<!-- abstract -->
		<div class="abstract">
			<div class="ab-ar ar">
				<div class="ab-title">الملخص:</div>
				<div class="abstarct-content ck-content" v-html="article.ar.description"></div>
			</div>
			<div class="ab-en en">
				<div class="ab-title">abstract:</div>
				<div class="abstarct-content ck-content" v-html="article.en.description"></div>
			</div>
			<a v-for="file in article.ar.File" :key="file" :href="file" target="_blank" class="download">
				<img src="/assets/Icons/download.png" alt="" />
				<p class="m-0">تحميل المقالة</p>
			</a>
		</div>
		<div class="keywords" v-if="article.ar.keyword.length > 0 || article.en.keyword.length > 0">
			<div class="main-title">
				<div class="mt-ar ar">الكلمات المفتاحية</div>
				<div class="mt-en en">keywords</div>
			</div>
			<div class="key-main">
				<div class="key-ar ar">
					<ul>
						<li v-for="keyword in article.ar.keyword" :key="keyword.id">
							<span v-if="keyword.name.length">
								{{ keyword.name }}
							</span>
						</li>
					</ul>
				</div>
				<div class="key-en en">
					<ul>
						<li v-for="keyword in article.en.keyword" :key="keyword.id">
							<span v-if="keyword.name.length">
								{{ keyword.name }}
							</span>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="refs" v-if="article.ar.Reference || article.en.Reference">
			<div class="main-title">
				<div class="ref-ar ar">المراجع</div>
				<div class="ref-en en">References</div>
			</div>
			<div class="ref-main">
				<div class="references-content ar ck-content" v-html="article.ar.Reference"></div>
				<div class="references-content en ck-content" v-html="article.en.Reference"></div>
			</div>
		</div>
	</div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs';
import Loader from '@/components/Loader';
import { momentRev } from '@/helpers';
import { mapGetters } from 'vuex';
export default {
	props: ['serieId', 'serieName', 'volumeId', 'volumeName', 'articleId', 'loadingSeriesAndVolumes'],

	components: {
		Breadcrumbs,
		Loader,
	},

	data() {
		return {
			loading: true,
			article: null,
		};
	},

	computed: {
		serie() {
			return this.getSerieById(this.serieId);
		},

		...mapGetters({
			getSerieById: 'series/getSerieById',
		}),
	},

	methods: {
		momentRev,
		backward(arr) {
			return arr.map((e) => e).reverse();
		},
	},

	mounted() {
		Promise.all([
			this.$store.dispatch('articles/fetchById', { id: this.articleId }).then((data) => {
				this.article = data;
			}),
		]).finally(() => {
			this.loading = false;
		});
	},
};
</script>

<style scoped>
.container {
	margin-top: 50px;
}
.container > * {
	margin: 0 50px;
}
.head {
	border-bottom: 2px solid var(--borders-color);
	padding: 10px 0 30px;
}
.top {
	padding: 20px 0;
	display: flex;
	justify-content: space-between;
}
.top * {
	font-family: changeMedium;
	font-size: 15px;
}
.top img {
	height: 30px;
	margin: 0 5px;
	display: inline-block;
}
.top p {
	font-size: 20px;
	max-width: 80%;
	margin: auto;
}
.h-main {
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 10px;
}
.h-main * {
	text-align: center !important;
}
.title * {
	font-family: changeBold;
	font-size: 26px;
}

.title {
	font-size: 30px;
	font-family: changeBold;
}
.date {
	color: grey;
}
.name {
	display: flex;
	align-items: center;
	padding: 10px 0;
	transform: translateX(10px);
}
.name img {
	height: 35px;
	margin: 0 5px;
	border-radius: 50%;
}
.name * {
	font-family: changeMedium;
	font-size: 14px;
}
.name .n-ar {
	text-align: right !important;
}

.abstract {
	padding: 30px 10px;
}
.abstract {
	line-height: 30px;
	font-size: 18px;
}
.ab-title {
	font-family: changeBold;
}
.download {
	margin-top: 30px;
	padding: 0 10px;
	display: inline-flex;
	justify-content: flex-end;
}
.download img {
	height: 30px;
	padding: 3px;
	margin: 0 5px;
}
.main-title {
	background: linear-gradient(to right, var(--yellow-color-2), var(--green-color));
	display: flex;
	justify-content: space-between;
	padding: 15px 30px;
	border-radius: 5px;
}
.main-title * {
	color: white;
	font-family: changeBoldSemi;
	font-size: 18px;
}
.keywords ul {
	padding: 0;
	display: flex;
	flex-wrap: wrap;
}
.keywords li {
	display: inline-block;
}
.keywords li:not(:first-child) span::before {
	content: ',';
	padding: 0 10px;
}
/* .keywords li:first-child::before {
	content: "";
	padding: 0;
} */
.refs ul {
	padding: 0;
	margin: 0;
	list-style-position: inside;
}
.key-main {
	padding: 30px 20px;
}
.ref-main {
	padding: 30px 0;
}
.key-main *,
.ref-main * {
	font-size: 18px;
	font-family: changeMedium;
	line-height: 35px;
}
.publisher-details {
	display: flex;
	flex-direction: column;
}
.publisher-details * {
	font-family: changeMedium;
	font-size: 14px;
}

@media only screen and (max-width: 992px) {
	.container > * {
		margin: 0 10px;
	}
}
@media only screen and (max-width: 575px) {
	.top {
		flex-direction: column;
		align-items: center;
	}
	.h-main {
		padding: 0;
	}
	.date {
		font-size: 14px;
	}
	.title * {
		font-size: 24px;
	}
	.name * {
		font-size: 12px;
	}
	.main-title {
		padding: 15px;
	}
	.main-title * {
		font-size: 16px;
	}
	.abstract {
		font-size: 16px;
	}
	.download {
		padding-top: 10px;
	}
	.key-main,
	.ref-main {
		padding: 20px 10px 10px;
	}
	.ref-main *,
	.key-main * {
		font-size: 14px;
	}
	.key-main ul {
		margin-bottom: 10px;
	}
	.key-main li,
	.ref-main li {
		line-height: 30px;
	}
}
</style>

<style>
.abstarct-content *,
.references-content * {
	font-family: change, sans-serif !important;
}
.abstarct-content table {
	width: 100% !important;
}
.abstarct-content pre,
.references-content pre {
	white-space: normal;
}
</style>
